var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportClockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 24.2,
    r: 16.05,
    stroke: "black",
    strokeWidth: 2.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 16.0526V25.5579L30.5368 31.8947",
    stroke: "black",
    strokeWidth: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportClockBlack);
export default __webpack_public_path__ + "static/media/icons-2_export-CLOCK-BLACK.968decbc884ba5151a232c9b87acaed2.svg";
export { ForwardRef as ReactComponent };